<template>
  <a-modal
    v-model:visible="state.deleteModalVisible"
    :footer="null"
    :width="480"
    @cancel="state.closeDeleteModal()"
  >
    <template #title>
      <div class="delete-modal__title">
        <warning-outlined class="delete-modal__title-icon" />
        <span>确认删除配置</span>
      </div>
    </template>
    <div class="delete-modal">
      <p class="delete-modal__desc">
        即将删除以下扶持配置，删除后不可恢复：
      </p>
      <div v-if="state.deleteRecord" class="delete-modal__info">
        <span class="delete-modal__category">
          {{ state.deleteRecord.categoryPath }}
        </span>
        <span class="delete-modal__cw">
          {{ state.deleteRecord.startCW }}–{{ state.deleteRecord.endCW }}
        </span>
      </div>
      <div class="delete-modal__footer">
        <a-button @click="state.closeDeleteModal()">取消</a-button>
        <a-button type="primary" danger @click="state.confirmDelete()">
          确认删除
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { inject } from 'vue'
import { WarningOutlined } from '@ant-design/icons-vue'

export default {
  name: 'DeleteConfirmModal',
  components: {
    WarningOutlined
  },
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>

<style lang="scss" scoped>
.delete-modal {
  &__title {
    display: flex;
    align-items: center;
    gap: 8px;

    &-icon {
      color: #faad14;
      font-size: 18px;
    }
  }

  &__desc {
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    margin-bottom: 24px;
  }

  &__category {
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }

  &__cw {
    font-size: 14px;
    color: #666;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
